import type { Theme } from '../../types/theme';

export const revolutTheme: Theme = {
  id: 'revolut',
  name: 'Revolut',
  description: 'Sleek dark fintech with gradient cards and premium polish',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/revolut/DESIGN.md',
  visualKeywords: ['dark', 'gradient cards', 'fintech', 'sleek', 'gradient'],
  colors: {
    background: '#000000',
    surface: '#0f0f0f',
    surfaceElevated: '#191919',
    textPrimary: '#ffffff',
    textSecondary: '#a0a0a0',
    textMuted: '#a0a0a0',
    border: '#1f1f1f',
    borderSubtle: '#292929',
    primary: '#d1d1d6',
    primaryHover: '#e0e0e5',
    primaryActive: '#b3b3b8',
    accent: '#d1d1d6',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'premium',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
